import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import BaseLoading from '../BaseLoading'
import showdown from 'showdown'

const MarkDown = ({ md }) => {
	const converter = new showdown.Converter()
	const html = converter.makeHtml(md)
	return <div className={CSS.mkSection} dangerouslySetInnerHTML={{ __html: html }}></div>
}

export default styled(MarkDown)``
